import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { ContactInfo } from '../../contact-info';
import { ContactInfoService } from '../../services/contact-info.service';
import { ContactUpdateComponent } from '../contact-update/contact-update.component';
import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { Product } from '../../../../js/static/Product';

@Component({
  selector: 'contact-widget',
  templateUrl: './contact-widget.component.html',
})
export class ContactWidgetComponent implements AfterViewInit {
  @Input() dismiss;
  @ViewChild('owner') ownerComponent: ContactUpdateComponent;
  @ViewChild('insured') insuredComponent: ContactUpdateComponent;

  readonly headerText: string = 'Let us know where to reach you.';
  ownerContactInfo: ContactInfo;
  insuredContactInfo: ContactInfo;
  showModal: boolean = false;
  sameOwnerInsured: boolean;
  readonly helpEmail: string;

  constructor(public contactUpdateService: ContactInfoService, public amorphicService: AmorphicService) {
    this.sameOwnerInsured =
      this.contactUpdateService.controller.customer.application.primaryPolicy.isOwnerSameAsInsured();
    this.helpEmail =
      Product.channels[amorphicService.controller.customer.application.primaryPolicy.getChannelCode()].helpEmail;
  }

  updateContact(): void {
    const ownerContact: ContactInfo = this.ownerComponent.getContactInfo();
    if (this.ownerComponent.checkChanged()) {
      this.contactUpdateService.updateContact(ownerContact, 'Owner');
      if (this.sameOwnerInsured) {
        const insured = ownerContact;
        ownerContact.id = this.contactUpdateService.insuredId;
        this.contactUpdateService.updateContact(insured, 'Insured');
      }
    }
    if (this.insuredContactInfo) {
      const insuredContact: ContactInfo = this.insuredComponent.getContactInfo();
      if (this.insuredComponent.checkChanged()) {
        this.contactUpdateService.updateContact(insuredContact, 'Insured');
      }
    }
    document.querySelector('body').classList.remove('modal-container__fullpage');
    this.dismiss();
  }

  isDisabled(): boolean {
    return (
      (!this.ownerComponent || this.ownerComponent.disableSubmit()) &&
      (!this.insuredComponent || (this.insuredComponent && this.insuredComponent.disableSubmit()))
    );
  }

  cancel(): void {
    if (
      this.ownerComponent !== undefined &&
      (this.ownerComponent.checkChanged() || (this.insuredComponent && this.insuredComponent.checkChanged()))
    ) {
      this.showModal = true;
    } else {
      document.querySelector('body').classList.remove('modal-container__fullpage');
      this.dismiss();
    }
  }

  closeModal(): void {
    this.showModal = false;
    document.querySelector('body').classList.remove('modal-container__fullpage');
  }

  isSameAddress(sameAdress: boolean) {
    if (sameAdress) {
      this.insuredComponent.updateContactInfoWithoutPhone(this.ownerComponent.getContactInfo());
    }
  }

  ngAfterViewInit(): void {
    this.contactUpdateService.getContactInfoPA().then(() => {
      this.ownerContactInfo = this.contactUpdateService.getContactInfo();
      this.ownerComponent.updateContactInfo(this.ownerContactInfo);
      if (!this.sameOwnerInsured) {
        this.insuredContactInfo = this.contactUpdateService.getContactInfoInsured();
        this.insuredComponent.updateContactInfo(this.insuredContactInfo);
        if (this.ownerContactInfo.hasSameAddress(this.insuredContactInfo)) {
          this.insuredComponent.changeSameAddress(true, false);
        }
      }
    });

    if (!this.sameOwnerInsured) {
      this.ownerComponent.contactFormGroup.valueChanges.subscribe(() => {
        if (this.insuredComponent.useSameAddress) {
          this.insuredComponent.updateContactInfoWithoutPhone(this.ownerComponent.getContactInfo());
        }
      });
    }
  }
}
